<template>
  <div id="about">
    <div id="desktop" v-if="$vuetify.breakpoint.lgAndUp">
      <section id="about-us">
        <v-container class="pb-0" style="margin-bottom: -24px">
          <img
            :src="require('@/assets/about-header-1450x291.webp')"
            style="
              aspect-ratio: 1450 / 291;
              width: 50rem;
              margin-bottom: -100px;
            "
          />
          <v-row>
            <v-col cols="12" md="7">
              <div class="py-12"></div>

              <v-responsive class="mb-8 mr-auto" max-width="720">
                <h2 class="font-weight-bold mb-3">
                  {{ headings[0] }}
                </h2>

                <div class="font-weight-light">
                  {{ text[0] }}
                </div>
              </v-responsive>

              <v-row class="pb-3">
                <v-col cols="12" md="5">
                  <v-responsive class="mb-4 mx-auto" max-width="720">
                    <h2 class="font-weight-bold mb-3">
                      {{ headings[1] }}
                    </h2>

                    <div class="font-weight-light">
                      {{ text[1] }}
                    </div>
                  </v-responsive>
                </v-col>
                <v-col cols="12" md="7">
                  <v-responsive class="mb-4 mx-auto" max-width="720">
                    <h2 class="font-weight-bold mb-3">
                      {{ headings[2] }}
                    </h2>

                    <div class="font-weight-light">
                      <ul>
                        <li>
                          <div v-html="text[2]"></div>
                        </li>
                        <li>
                          <div v-html="text[3]"></div>
                        </li>
                        <li>
                          <div v-html="text[4]"></div>
                        </li>
                        <li>
                          <div v-html="text[5]"></div>
                        </li>
                      </ul>
                    </div>
                  </v-responsive>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="5" class="align-content-end">
              <img
                :src="
                  require('@/assets/team/2025-08-19/ret anri1-cropped.webp')
                "
                style="aspect-ratio: 870 / 1369; height: 47.8125rem"
              />
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="our-team" style="margin-bottom: -12px">
        <img
          :src="require('@/assets/team/2025-08-19/about-team-1920x882.webp')"
          style="aspect-ratio: 1920 / 882; width: 100%"
        />
      </section>

      <section id="i-am-miss-anri" style="background-color: #ffebf6">
        <!-- <div class="py-8"></div> -->

        <v-container class="pb-0">
          <v-row>
            <v-col cols="12" class="d-flex">
              <img
                :src="require('@/assets/my-story.webp')"
                style="aspect-ratio: 676 / 194; width: 400px"
                :style="$vuetify.breakpoint.xl ? 'margin-left: 220px;' : ''"
              />
            </v-col>

            <v-col cols="12" md="4" class="d-flex justify-end">
              <img
                :src="
                  require('@/assets/team/2025-08-19/ret anri2-cropped.webp')
                "
                style="aspect-ratio: 819 / 1442; width: 23.125rem"
              />
            </v-col>
            <v-col cols="12" md="8" class="align-content-center">
              <v-responsive
                class="font-weight-light mb-8 mx-auto"
                max-width="720"
              >
                <span v-html="text[6]"></span>
              </v-responsive>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </div>

    <div id="mobile-large" v-if="$vuetify.breakpoint.md">
      <section id="about-us">
        <v-container class="pb-0" style="margin-bottom: -24px">
          <img
            :src="require('@/assets/about-header-1450x291.webp')"
            style="
              aspect-ratio: 1450 / 291;
              width: 50rem;
              margin-bottom: -100px;
            "
          />
          <v-row>
            <v-col cols="12" md="7">
              <div class="py-12"></div>

              <v-responsive class="mb-8 mr-auto" max-width="720">
                <h2 class="font-weight-bold mb-3">
                  {{ headings[0] }}
                </h2>

                <div class="font-weight-light">
                  {{ text[0] }}
                </div>
              </v-responsive>

              <v-row class="pb-3">
                <v-col cols="12" md="5">
                  <v-responsive class="mb-4 mx-auto" max-width="720">
                    <h2 class="font-weight-bold mb-3">
                      {{ headings[1] }}
                    </h2>

                    <div class="font-weight-light">
                      {{ text[1] }}
                    </div>
                  </v-responsive>
                </v-col>
                <v-col cols="12" md="7">
                  <v-responsive class="mb-4 mx-auto" max-width="720">
                    <h2 class="font-weight-bold mb-3">
                      {{ headings[2] }}
                    </h2>

                    <div class="font-weight-light">
                      <ul>
                        <li>
                          <div v-html="text[2]"></div>
                        </li>
                        <li>
                          <div v-html="text[3]"></div>
                        </li>
                        <li>
                          <div v-html="text[4]"></div>
                        </li>
                        <li>
                          <div v-html="text[5]"></div>
                        </li>
                      </ul>
                    </div>
                  </v-responsive>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="5" class="align-content-end">
              <img
                :src="
                  require('@/assets/team/2025-08-19/ret anri1-cropped.webp')
                "
                style="aspect-ratio: 870 / 1369; height: 80vh"
              />
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="our-team" style="margin-bottom: -12px">
        <img
          :src="require('@/assets/team/2025-08-19/about-team-1920x882.webp')"
          style="aspect-ratio: 1920 / 882; width: 100%"
        />
      </section>

      <section id="i-am-miss-anri" style="background-color: #ffebf6">
        <!-- <div class="py-6"></div> -->

        <v-container class="pb-0">
          <v-row>
            <v-col cols="12" class="d-flex">
              <img
                :src="require('@/assets/my-story.webp')"
                style="aspect-ratio: 676 / 194; width: 400px"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-responsive>
                <v-img
                  :src="
                    require('@/assets/team/2025-08-19/ret anri2-cropped.webp')
                  "
                >
                </v-img>
              </v-responsive>
            </v-col>
            <v-col cols="12" md="8" class="align-content-center">
              <v-responsive
                class="font-weight-light mb-8 mx-auto"
                max-width="720"
              >
                <span v-html="text[6]"></span>
              </v-responsive>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </div>

    <div id="mobile-small" v-if="$vuetify.breakpoint.smAndDown">
      <section id="about-us">
        <v-container class="pb-0" style="margin-bottom: -24px">
          <img
            :src="require('@/assets/about-header-1450x291.webp')"
            style="aspect-ratio: 1450 / 291; width: 100%"
          />
          <v-row class="px-3 pb-6">
            <v-col cols="12" class="align-content-center px-0">
              <div>
                <img
                  :src="
                    require('@/assets/team/2025-08-19/ret anri1-cropped.webp')
                  "
                  style="
                    aspect-ratio: 870 / 1369;
                    width: 35.5vw;
                    float: right;
                    margin-bottom: 4px;
                    margin-left: 8px;
                  "
                />
                <h2 class="font-weight-bold">
                  {{ headings[0] }}
                </h2>
                <span v-html="text[0]"></span>
                <h2 class="font-weight-bold pt-2">
                  {{ headings[1] }}
                </h2>
                <span v-html="text[1]"></span>
              </div>
            </v-col>

            <!-- <v-col cols="7" class="px-0">

            <v-responsive class="mb-8 mx-auto" max-width="720">
              <h2 class="font-weight-bold">
                {{ headings[0] }}
              </h2>

              <div class="font-weight-light">
                {{ text[0] }}
              </div>
            </v-responsive>
          </v-col> -->

            <!-- <v-col cols="5" class="d-flex justify-center px-0">
            <div>
            <img :src="require('@/assets/team/2025-08-19/ret anri1-cropped.webp')"
              style="aspect-ratio: 870 / 1369; width: 100%;" />
              </div>
          </v-col> -->

            <!-- <v-row class="pb-3">
              <v-col cols="12" md="5" class="pt-0" style="margin-top: -24px;">
                <v-responsive class="mb-6 mx-auto" max-width="720">
                  <h2 class="font-weight-bold">
                    {{ headings[1] }}
                  </h2>

                  <div class="font-weight-light">
                    {{ text[1] }}
                  </div>
                </v-responsive>
              </v-col>
            </v-row> -->
          </v-row>
        </v-container>
      </section>

      <section id="our-team" style="margin-bottom: -12px">
        <img
          :src="require('@/assets/team/2025-08-19/about-team-1920x882.webp')"
          style="aspect-ratio: 1920 / 882; width: 100%"
        />
      </section>

      <section id="i-am-miss-anri" style="background-color: #ffebf6">
        <v-container class="pb-0">
          <v-row class="px-3">
            <v-col cols="12" class="d-flex justify-center">
              <img
                :src="require('@/assets/my-story.webp')"
                style="aspect-ratio: 676 / 194; width: 50%"
              />
            </v-col>

            <v-col cols="12" class="align-content-center px-0">
              <p>
                <img
                  :src="
                    require('@/assets/team/2025-08-19/ret anri2-cropped.webp')
                  "
                  style="
                    aspect-ratio: 819 / 1442;
                    width: 35.5vw;
                    float: right;
                    margin-bottom: 4px;
                    margin-left: 8px;
                  "
                />
                <span v-html="text[6]"></span>
              </p>
            </v-col>

            <!-- <v-col cols="7" class="px-0 pb-0" style="height: fit-content;">
            <v-responsive class="mx-auto" max-width="720">
              <div class="font-weight-light" style="line-height: 1; font-size: 1rem;">
                {{ text[6] }}
              </div>
            </v-responsive>
          </v-col>

          <v-col cols="5" class="d-flex justify-center px-0 pb-0" style="height: 188px;">
            <div style="margin-top: -30px;">
            <img :src="require('@/assets/team/2025-08-19/ret anri2-cropped.webp')"
              style="aspect-ratio: 819 / 1442; height: 100%;" />
              </div>
          </v-col>
          
          <v-col cols="12" class="align-content-center px-0">
            <v-responsive class="font-weight-light mb-8 mx-auto" max-width="720" style="line-height: 1; font-size: 1rem;">
              {{ text[7] }}
            </v-responsive>
          </v-col> -->
          </v-row>
        </v-container>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "AboutView",
  data: () => ({
    headings: ["Introduction", "Our Vision", "What we believe"],
    text: [
      `Welcome to Juffrou Anri, where innovation meets education. “Juffrou” means teacher in Afrikaans. We are a
            passionate team of educators dedicated to revolutionising teaching and learning. Our mission is to empower
            educators across South Africa with the tools and resources they need to create engaging, effective, and
            personalised learning experiences.`,

      `At Juffrou Anri, we have a vision: to redefine education through innovative technology. We believe every
                learner deserves an exceptional education, and every educator should have the tools to make it possible.
                Our platform is designed to bridge the gap between traditional teaching methods and the limitless
                possibilities of modern technology.`,

      `<strong>Empowerment.</strong> We believe in empowering educators with the latest technology to
                    inspire the next generation of leaders.`,

      `<strong>Innovation.</strong> We’re dedicated to staying at the forefront of educational technology,
                    continuously improving our platforms to meet your evolving needs.`,

      `<strong>Simplicity.</strong> Our user-friendly interfaces save educators time, making their work
                    more efficient and enjoyable.`,

      `<strong>Community.</strong> We’re building a supportive community of educators where ideas are
                    shared, collaboration thrives, and learning never stops.`,

      `Just after I graduated from the Cape Peninsula University of Technology in South Africa, the reality of COVID-19 and the lockdowns created a unique opportunity. During the pandemic, I identified an urgent need: teachers and learners lacked resources that matched the ATP.
Driven by my deep love of teaching, I took on the challenge and developed my first product, a Life Skills Grade 4 workbook. The demand for these resources grew rapidly.<br><br>
While working as a substitute teacher for a few months, it became clear that my heart not only belonged to the classroom, but also to this business. With big dreams and determination, I decided to give it my all—not just for extra income, but to make Juffrou Anri the largest educational resource business in South Africa.
In 2021 we started building an incredible team. We are growing daily, driven by a massive passion for education and learning.<br>
We understand the mental health challenges teachers face, especially in these challenging times, and we’re here to help. Our dream has always been big—to make an impact and serve as a pillar of support for teachers and parents across the country. For us it is much more than just a business!<br>
On January 1, 2024, we launched Juffrou Anri’s new website, which aims to revolutionise teaching through technology. Inspired by my immeasurable love for teaching, we are focused on being there for teachers and parents every step of the way.`,
    ],
  }),
};
</script>
